// extracted by mini-css-extract-plugin
module.exports = {"popUpTitle":"style_popUpTitle__Hymqr","leftPos":"style_leftPos__8Wx7W"};